// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RSPBprogressBar {
  height: 10px;
  line-height: 1;
  border-radius: 10px;
  position: relative;
  background-color: rgba(211, 211, 211, 0.6);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 0; }
  .RSPBprogressBar .RSPBstep {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    z-index: 0;
    position: absolute;
    transform: translateX(-50%);
    transition-property: all;
    transition-timing-function: ease; }
  .RSPBprogressBar .RSPBprogressBarText {
    color: white;
    font-size: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); }
  .RSPBprogressBar .RSPBprogression {
    position: absolute;
    transition: width 0.3s ease;
    left: 0;
    top: 0;
    bottom: 0;
    border-radius: 10px;
    background: rgba(0, 116, 217, 0.8);
    z-index: -1; }
`, "",{"version":3,"sources":["webpack://./node_modules/react-step-progress-bar/styles.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU,EAAE;EACZ;IACE,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,2BAA2B;IAC3B,wBAAwB;IACxB,gCAAgC,EAAE;EACpC;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC,EAAE;EACpC;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,OAAO;IACP,MAAM;IACN,SAAS;IACT,mBAAmB;IACnB,kCAAkC;IAClC,WAAW,EAAE","sourcesContent":[".RSPBprogressBar {\n  height: 10px;\n  line-height: 1;\n  border-radius: 10px;\n  position: relative;\n  background-color: rgba(211, 211, 211, 0.6);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 0; }\n  .RSPBprogressBar .RSPBstep {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 0;\n    position: absolute;\n    transform: translateX(-50%);\n    transition-property: all;\n    transition-timing-function: ease; }\n  .RSPBprogressBar .RSPBprogressBarText {\n    color: white;\n    font-size: 10px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%); }\n  .RSPBprogressBar .RSPBprogression {\n    position: absolute;\n    transition: width 0.3s ease;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    border-radius: 10px;\n    background: rgba(0, 116, 217, 0.8);\n    z-index: -1; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
